import { SECTIONS } from '@/constants/hcpSections';

export function sectionIdFromRoute(route) {
  const map = {
    filiation: SECTIONS.FILIATION_DATA,
    reason: SECTIONS.CONSULT_REASON,
    interview: SECTIONS.INTERVIEW_DISPOSITION,

    "physical-condition": SECTIONS.ASPECT_PHYSICAL_SENSORY_MOT,
    dysfunctions: SECTIONS.ASPECT_PHYSICAL_SENSORY_MOT,
    psychomotor: SECTIONS.ASPECT_PHYSICAL_SENSORY_MOT,
    "CAxAFSMxClarifications": SECTIONS.ASPECT_PHYSICAL_SENSORY_MOT,

    "basic-habits": SECTIONS.ASPECT_PHYSIOL_FUNCTIONAL,
    "symptoms-pshysiol": SECTIONS.ASPECT_PHYSIOL_FUNCTIONAL,
    "symptoms-muscular": SECTIONS.ASPECT_PHYSIOL_FUNCTIONAL,
    "CAxAFFxClarifications": SECTIONS.ASPECT_PHYSIOL_FUNCTIONAL,

    attention: SECTIONS.ASPECT_COGNITIVE,
    perception: SECTIONS.ASPECT_COGNITIVE,
    memory: SECTIONS.ASPECT_COGNITIVE,
    thoughtPt1: SECTIONS.ASPECT_COGNITIVE,
    thoughtPt2: SECTIONS.ASPECT_COGNITIVE,
    thoughtPt3: SECTIONS.ASPECT_COGNITIVE,
    language: SECTIONS.ASPECT_COGNITIVE,
    "CAxACGxClarifications": SECTIONS.ASPECT_COGNITIVE,

    personality: SECTIONS.ASPECT_PERSONALITY,
    "CAxARPxClarifications": SECTIONS.ASPECT_PERSONALITY,

    affectivity: SECTIONS.ASPECT_AFFECTIVITY_MOTIV,
    "CAxAAMxClarifications": SECTIONS.ASPECT_AFFECTIVITY_MOTIV,

    behavioral: SECTIONS.ASPECT_BEHAVIORAL,
    "CAxACOxClarifications": SECTIONS.ASPECT_BEHAVIORAL,

    family: SECTIONS.ASPECT_FAMILY,
    relationshipFam: SECTIONS.ASPECT_FAMILY,
    violenceFam: SECTIONS.ASPECT_FAMILY,
    "CAxAFAxClarifications": SECTIONS.ASPECT_FAMILY,

    socialSkills: SECTIONS.ASPECT_SOCIAL,
    interestsSoc: SECTIONS.ASPECT_SOCIAL,
    substances: SECTIONS.ASPECT_SOCIAL,
    couple: SECTIONS.ASPECT_SOCIAL,
    losses: SECTIONS.ASPECT_SOCIAL,
    violenceSoc: SECTIONS.ASPECT_SOCIAL,
    "CAxASCxClarifications": SECTIONS.ASPECT_SOCIAL,

    sexual: SECTIONS.ASPECT_SEXUAL,
    "CAxASXxClarifications": SECTIONS.ASPECT_SEXUAL,

    academic: SECTIONS.ASPECT_ACADEMIC_LABOR,
    labor: SECTIONS.ASPECT_ACADEMIC_LABOR,
    "CAxAALxClarifications": SECTIONS.ASPECT_ACADEMIC_LABOR,

    "specific-conditions": SECTIONS.SPECIFIC_CONDITIONS,
    "CAxCExClarifications": SECTIONS.SPECIFIC_CONDITIONS,

    infancy: SECTIONS.BACK_DEVELOPMENT,
    childhood: SECTIONS.BACK_DEVELOPMENT,
    adolescence: SECTIONS.BACK_DEVELOPMENT,
    "specific-situations": SECTIONS.BACK_DEVELOPMENT,

    membersfam: SECTIONS.BACK_FAMILY,

    "basic-studies": SECTIONS.BACK_ACADEMIC_LABOR,
    "superior-studies": SECTIONS.BACK_ACADEMIC_LABOR,
    jobs: SECTIONS.BACK_ACADEMIC_LABOR,

    mental: SECTIONS.BACK_PSYC_PSYQ_MED,
    medical: SECTIONS.BACK_PSYC_PSYQ_MED,
    drugs: SECTIONS.BACK_PSYC_PSYQ_MED,
    medications: SECTIONS.BACK_PSYC_PSYQ_MED,

    violence: SECTIONS.BACK_VIOLENCE,
    criminal: SECTIONS.BACK_CRIMINAL,
    "relevant-events": SECTIONS.BACK_RELEVANT_EVENTS,
    "ANxClarifications": SECTIONS.BACK_OBSERVATIONS,

    "details-symptoms": SECTIONS.DETAILS_SYMPTOMS,
    diagTreatment: SECTIONS.DIAGNOSIS_TREATMENT,
    generalObservation: SECTIONS.GENERAL_OBSERVATIONS,

    "test-applied": SECTIONS.TESTS,
    "correctors": SECTIONS.TESTS,
    "list": SECTIONS.TESTS,
    "co-01": SECTIONS.TESTS,
    "co-02": SECTIONS.TESTS,
    "co-03": SECTIONS.TESTS,
    "co-04": SECTIONS.TESTS,
    "co-05": SECTIONS.TESTS,
    "co-15": SECTIONS.TESTS,
    "co-16": SECTIONS.TESTS,
    "co-17": SECTIONS.TESTS,
    "co-18": SECTIONS.TESTS,
    "co-20": SECTIONS.TESTS,
    "co-35": SECTIONS.TESTS,
    "co-39": SECTIONS.TESTS,
    "co-41": SECTIONS.TESTS,
    "co-43": SECTIONS.TESTS,
    "co-44": SECTIONS.TESTS,
    "co-45": SECTIONS.TESTS,
    "co-46": SECTIONS.TESTS,
    "co-51": SECTIONS.TESTS,
    "co-52": SECTIONS.TESTS,
    "co-55": SECTIONS.TESTS,
    "test-result": SECTIONS.TESTS,

    report: SECTIONS.FILIATION_DATA,
  };

  return map[route.name] || null;
}
